import StoreProvider from './StoreProvider';

export default StoreProvider;
